export default {
  name: "shippop",
  webTitle: "POP SHIPPOP",
  // primaryColor: "#11cdef",
  // secondaryColor: "#11cdefb0",
  backgroundColor: "#0b9dd1",
  contactURL: "https://lin.ee/oPJTwpD",
  shopCodePrefix: "PS",
  showChangelog: true,
  serviceName: {
    lazada: true,
    dhl: true,
    shippop: true,
    shopee: true,
    doubleA: true,
    kerry: true,
    kerry_quick: false,
  },
  manageVision: {
    brancePackage: true,
    menuTopUpCreditSA: true,
  },
  unitKG: false,
  manageDisable: {
    weightSuperAdmin: false,
    dimensionSuperAdmin: false,
    costSuperAdmin: false,
  },
  dropoffKerry: false,
  dropoffEasyShip: false,
  dropoffKerryOption: {
    manual:
      "https://docs.google.com/presentation/d/1sralwUyDy9um2pq8-a-mkJRbiHLpYLIRyZJwkRu7ygU/edit?usp=sharing",
    vdoHowTo: "https://shippop.live/kerrydop",
  },
  bannerCampaignPosition: "DF_POSPOPSHOP",
  btnCancelBill: false,
};
